webpackJsonp([1],{

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingView_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1672efb8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingView_vue__ = __webpack_require__(594);
function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1672efb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1672efb8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNav_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4d117b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNav_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c4d117b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4d117b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HistoryVideoView_vue__ = __webpack_require__(357);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      /*
        This will be the start of modify entire brand for site
      */
      'theme': {
        background: 'black'
      },
      menuClasses: 'hamburger hamburger--collapse',
      modalMenuClasses: 'modalMenu',
      historyVideoView: __WEBPACK_IMPORTED_MODULE_0__components_HistoryVideoView_vue__["a" /* default */],
      historyVideoUrl: null
    };
  },

  name: 'app',
  methods: {
    /*
    beforeOpen(event) {
      this.historyVideoUrl = event.params.foo
      alert(event.params.foo)
    },
    */
    toggleMenu: function toggleMenu() {
      if (!this.menuClasses.includes("is-active")) {
        this.menuClasses = 'hamburger hamburger--collapse is-active';
        this.modalMenuClasses = 'modalMenu show';
      } else {
        this.menuClasses = 'hamburger hamburger--collapse';
        this.modalMenuClasses = 'modalMenu';
      }
    }
  }
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imgValue: "",
      wrapperClass: ""
    };
  },

  mounted: function mounted() {
    /**
      i don't remember why but it tooks some wrangling to get the
      wistia player loaded with dynamic attributes.
      rp - 7/1/19
    **/

    var script1 = document.createElement('script');
    var script2 = document.createElement('script');

    // Set player dynamic vars by video id
    this.imgValue = "https://fast.wistia.com/embed/medias/" + this.$store.state.completionStepForModal.videoId + "/swatch";
    this.wrapperClass = "wistia_embed wistia_async_" + this.$store.state.completionStepForModal.videoId + " videoFoam=true";

    script1.src = this.$store.state.completionStepForModal.url;
    script1.async = true;

    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoView_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Practice_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_battles_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_misc__ = __webpack_require__(315);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    test: function test() {
      alert("Test");
    },


    //Cheking if the users answer is true or false.
    checkAnswer: function checkAnswer(choice, correctAnswer) {
      //Checks if choice is equal to the correct answer.
      //If correct the lesson will continue, if false the user will recieve a prompt to return to the previous video.
      if (choice === correctAnswer) {
        alert("That answer is correct! Let's move on!");
        this.completeStep();
      } else {
        alert("That was incorrect, would you like to try again?");
        this.previousStep();
      }
    },


    // Assumes no loaded step
    getNextStep: function getNextStep() {
      this.$store.commit('getNextStep');
    },
    getCompletions: function getCompletions() {
      this.$store.commit('getCompletions');
    },
    completeStep: function completeStep() {
      this.$store.commit('completeStep', this.$store.state.step);
      this.$store.commit('getCompletions');
    },


    // NOTE : previousStep decisionDescrtiptiont always work, if coming from decision
    // leaving out for now
    previousStep: function previousStep() {
      this.$store.commit('previousStep', this.$store.state.step);
    },
    setChain: function setChain(decision) {
      this.$store.commit('setChain', decision);
    },
    open: function open() {
      this.$modal.show(__WEBPACK_IMPORTED_MODULE_1__VideoView_vue__["a" /* default */], {
        adaptive: true
      }, {
        width: "80%",
        height: "80%"
      });
    },
    getUser: function getUser() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_3__utils_battles_api__["g" /* getUser */])().then(function (user) {
        // Set user
        // if user is unpaid, reset to begin route for payment
        _this.$store.commit('setUser', user);

        //if (!user.payment || user.payment.duration == 0) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["a" /* showPayment */])(user)) {
          _this.$router.push({ path: '/' });
        }
      }).catch(function (error) {
        console.log(error);
        // alert("error")
      });
    }
  },
  mounted: function mounted() {
    this.getUser();
    this.getNextStep();
    this.getCompletions();
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imgValue: "",
      wrapperClass: ""
    };
  },

  mounted: function mounted() {
    /**
      i don't remember why but it tooks some wrangling to get the
      wistia player loaded with dynamic attributes.
      rp - 7/1/19
    **/

    var script1 = document.createElement('script');
    var script2 = document.createElement('script');

    // Set player dynamic vars by video id
    this.imgValue = "https://fast.wistia.com/embed/medias/" + this.$store.state.step.videoId + "/swatch";
    this.wrapperClass = "wistia_embed wistia_async_" + this.$store.state.step.videoId + " videoFoam=true";

    script1.src = this.$store.state.step.url;
    script1.async = true;

    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }
});

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chart__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_battles_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {
      chart: __WEBPACK_IMPORTED_MODULE_0__Chart__["a" /* default */],
      minutes: 0,
      notes: "",
      practiceLengths: [{ label: "10 minutes", minutes: 10 }, { label: "20 minutes", minutes: 25 }, { label: "30 minutes", minutes: 30 }, { label: "45 minutes", minutes: 45 }, { label: "1 hour", minutes: 60 }],
      sessions: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_1__utils_battles_api__["d" /* getPracticeSessions */])().then(function (sessions) {
      console.log(sessions);
      _this.sessions = sessions;
      alert("gotem");
    }).catch(function (error) {
      alert("erorr here");
      console.log(error);
    });
  },

  methods: {
    save: function save() {
      alert("hey there");
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_battles_api__["j" /* savePracticeSession */])(this.minutes, this.notes).then(function (sessions) {
        console.log(sessions);
        alert("done");
      }).catch(function (error) {
        alert("erorr here");
        console.log(error);
      });
    },
    setOption: function setOption(minutes) {
      this.minutes = minutes;
    }
  }
});

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__(126);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0073cc8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(369);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  data: function data() {
    return {
      chartdata: {
        labels: ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri'],
        datasets: [{
          label: 'Time spent',
          backgroundColor: '#c3375b',
          data: [40, 10, 20, 0, 10, 10]
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted: function mounted() {
    this.renderChart(this.chartdata, this.options);
  },

  methods: {}
});

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPublicStartupBattles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPrivateStartupBattles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNextStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return completeStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return previousStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setChain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setPreference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return makePayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return savePracticeSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPracticeSessions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCompletions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(26);



// TODO: get this from env
var BASE_URL = "https://trailtones.herokuapp.com"; //'http://localhost:3333'

//alert(process.env.API_BASE_URL)
function getPublicStartupBattles() {
  var url = BASE_URL + '/api/battles/public';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
    return response.data;
  });
}

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  // TODO: this is not very sustainable as there will be more routes
  if (error.response.status === 401 && window.location.href.includes("home")) {

    // clear tokens just incase client logic thought user was logged in.
    Object(__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* clearTokens */])();
    window.location = "/";
  }

  return error;
});

function getNextStep() {
  var url = BASE_URL + '/api/current';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  }).catch(function (err) {
    console.log(err);
  });
}

function getCompletions() {
  var url = BASE_URL + '/api/completions';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function completeStep(step) {
  var url = BASE_URL + '/api/complete';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, step, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function previousStep(step) {
  var url = BASE_URL + '/api/previous';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, step, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function setChain(decision) {
  var url = BASE_URL + '/api/changeChain';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, decision, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function getPrivateStartupBattles() {
  var url = BASE_URL + '/api/battles/private';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
    headers: {
      Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])()
    }
  }).then(function (response) {
    return response.data;
  });
}

function setPreference(decision) {
  var url = BASE_URL + '/api/setPreference';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, decision, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function makePayment(token) {
  var url = BASE_URL + '/api/payment';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, { token: token }, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function getUser() {
  var url = BASE_URL + '/api/user';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function getPracticeSessions() {
  var url = BASE_URL + '/api/practiceSessions';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}

function savePracticeSession(minutes, notes) {
  var url = BASE_URL + '/api/practiceSessions';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
    minutes: minutes,
    notes: notes
  }, { headers: { Authorization: 'Bearer ' + Object(__WEBPACK_IMPORTED_MODULE_1__auth__["b" /* getAccessToken */])() } }).then(function (response) {
    return response.data;
  });
}



/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearTokens;
/* harmony export (immutable) */ __webpack_exports__["e"] = logout;
/* harmony export (immutable) */ __webpack_exports__["f"] = requireAuth;
/* unused harmony export getIdToken */
/* harmony export (immutable) */ __webpack_exports__["b"] = getAccessToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = setAccessToken;
/* harmony export (immutable) */ __webpack_exports__["h"] = setIdToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = isLoggedIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_auth0_lock__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_auth0_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_auth0_lock__);





var ID_TOKEN_KEY = 'id_token';
var ACCESS_TOKEN_KEY = 'access_token';

var AUTH0_CLIENT_ID = "VvCLGC2P0K9n0JLQlhpozVPwfJxCy34l"; // 'VvCLGC2P0K9n0JLQlhpozVPwfJxCy34l'
var AUTH0_CLIENT_DOMAIN = "trailtones.auth0.com"; // 'trailtones.auth0.com'

// Hack to static callbck file
// Hash in URL messes things up
// this file redirect back to the callback accepting route /callback
// which will write the access token to local storage
var REDIRECT = "https://trailtones.com/auth-callback.html"; // 'http://localhost:8080/auth-callback.html'

var SCOPE = 'full_access';
var AUDIENCE = 'https://www.trailtones.com';

var auth = new __WEBPACK_IMPORTED_MODULE_2_auth0_js__["default"].WebAuth({
  clientID: AUTH0_CLIENT_ID,
  domain: AUTH0_CLIENT_DOMAIN
});

function login() {

  auth.authorize({
    responseType: 'token id_token',
    scope: 'openid email profile',
    redirectUri: REDIRECT,
    audience: AUDIENCE,
    prompt: 'login'
  });
}

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history'
});

function clearTokens() {
  clearIdToken();
  clearAccessToken();
}

function logout() {
  clearIdToken();
  clearAccessToken();
  router.go('/');
}

function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

function getIdToken() {
  console.log(window.location.hash);
  return localStorage.getItem(ID_TOKEN_KEY);
}

function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  //debugger
  var match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

// Get and store access_token in local storage
function setAccessToken() {
  var accessToken = getParameterByName('access_token');
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store id_token in local storage
function setIdToken() {
  var idToken = getParameterByName('id_token');
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}

function isLoggedIn() {
  var idToken = getIdToken();
  return !!idToken && !isTokenExpired(idToken);
}

function getTokenExpirationDate(encodedToken) {
  var token = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(encodedToken);
  if (!token.exp) {
    return null;
  }

  var date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  var expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showPayment;
function showPayment(user) {

  // User has paid
  if (user.payment && user.payment.duration > 0) {
    return false;
  }

  // User is in trial
  // check if trial is expired, if so update localStorage
  // show payment
  if (JSON.parse(localStorage.isTry) === true) {

    var ts = Date.parse(localStorage.trialStart);
    var now = new Date();
    var diff = now - ts;

    console.log("trial age ms: ", diff);

    if (diff / 1200000 > 23) {
      localStorage.isTry = false;
      return true;
    }
    return false;
  }

  // User has not paid
  if (user.payment && user.payment.duration == 0) {
    return true;
  }

  // default to show payment
  return true;
}

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_battles_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Payment__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__onboarding_OnboardingView__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-nav',
  data: function data() {
    return {
      paymentComponent: __WEBPACK_IMPORTED_MODULE_3__Payment__["a" /* default */],
      onboardingComponent: __WEBPACK_IMPORTED_MODULE_4__onboarding_OnboardingView__["a" /* default */]
    };
  },

  methods: {
    handleTrial: function handleTrial() {
      gtag_report_trial_start();
      localStorage.isTry = true;
      localStorage.trialStart = new Date();
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* login */])();
    },
    showPayment: function showPayment() {

      // dont show payment if user is not logged in
      if (!this.$store.state.user) {
        return false;
      }

      // If we dont's
      //if (!this.showOnboarding() && !showPayment(this.$store.state.user)){

      //}

      return !this.showOnboarding() && Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["a" /* showPayment */])(this.$store.state.user);
    },
    showOnboarding: function showOnboarding() {
      return this.$store.state.user && this.$store.state.user.preferences && !this.$store.state.user.preferences.goal;
    },
    handleCustomer: function handleCustomer() {
      localStorage.isTry = false;
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* login */])();
    },
    handleLogout: function handleLogout() {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["e" /* logout */])();
    },
    isLoggedIn: function isLoggedIn() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["c" /* isLoggedIn */])();
    },
    getUser: function getUser() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__utils_battles_api__["g" /* getUser */])().then(function (user) {
        // Set user
        _this.$store.commit('setUser', user);

        // if user paid, redirect to home
        // payment component also will redirect to home upon successful payment
        if (user.payment && user.payment.duration > 0) {
          // alert("paid")
          _this.$router.push({ path: 'home' });
        }

        // if trialing and have prefs set, go home
        if (user.preferences && user.preferences.goal && JSON.parse(localStorage.isTry) === true) {
          _this.$router.push({ path: 'home' });
        }
      }).catch(function (error) {
        console.log(error);
        //alert("error")
      });
    }
  },
  mounted: function mounted() {
    this.getUser();
    /*
    if (!this.isLoggedIn()) {
      alert("not logged in")
      this.handleLogin()
    }
    */
  }
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6e2c0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(583);
function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a6e2c0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6e2c0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements_plus__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_battles_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {

    return {
      complete: false,
      stripeKey: "pk_live_RETNIsbf6PFCS2oTJhXlOmsD",
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      isPaying: false
    };
  },


  components: { Card: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements_plus__["Card"] },
  methods: {
    /*
    getStarted () {
      this.$router.push({ path: 'home' })
    },
    */
    pay: function pay() {
      var _this = this;

      if (!this.complete) {
        alert("Please enter your payment details");
        return;
      }

      this.isPaying = true;

      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      Object(__WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements_plus__["createToken"])().then(function (data) {
        if (!data.token) {
          alert("Sorry, something unexpected happened, please contact support");
          _this.isPaying = false;
          console.log("No token", data);
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__utils_battles_api__["h" /* makePayment */])(data.token.id).then(function (user) {
          gtag_report_conversion();
          _this.isPaying = false;
          // Set User - redirect to home
          _this.$store.commit('setUser', user);
          // need better hasPaid method
          _this.$router.push({ path: 'home' });
          //this.paymentSubmitted = true
        }).catch(function (error) {
          alert("Sorry, something unexpected happened");
          _this.isPaying = false;
          console.log(error);
        });
      });
    }
  }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Question__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Question2__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Question3__ = __webpack_require__(591);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      step: 0,
      currentComponent: __WEBPACK_IMPORTED_MODULE_0__Question__["a" /* default */],
      components: [__WEBPACK_IMPORTED_MODULE_0__Question__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__Question2__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__Question3__["a" /* default */]],
      disabled: false
    };
  },

  methods: {
    increment: function increment() {
      if (this.step === this.components.length - 1) {
        this.setPreference();
        return;
      }

      this.step = this.step + 1;
      this.currentComponent = this.components[this.step];
      window.scroll(0, 0);
    },
    setPreference: function setPreference() {
      this.$store.commit('setPreference', this.$store.state.preference);
    },
    canProceed: function canProceed() {
      return false;
    }
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OnboardingView__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    preference: function preference() {
      return this.$store.state.preference;
    }
  },
  data: function data() {
    return {
      questions: [{
        title: "Curious",
        context: "Looks like fun, would like to give it a shot.",
        id: "starting-learn-and-play-songs",
        blurb: 'Dipping your toes',
        selected: false
      }, {
        title: "Motivated",
        context: 'Ready for work, i want to play!',
        id: 'starting-learn-and-grow',
        blurb: 'Ready to commit...',
        selected: false
      }, {
        title: "Digging In",
        context: 'Love music, i want this to be a big part of my life',
        id: 'experienced-looking-for-growth',
        blurb: 'Kick my ass please...',
        selected: false
      }]
    };
  },

  methods: {
    setLookingFor: function setLookingFor(questionID) {

      this.questions.forEach(function (question, index) {
        console.log(question);
        if (question.id === questionID) {
          question.selected = true;
        } else {
          question.selected = false;
        }
      });

      this.$store.commit('setLookingFor', questionID);
    }
  }
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      questions: [{
        title: "Wing it",
        blurb: "Find time as you go",
        context: "See how you feel, practice when you can",
        id: "5-10-min",
        selected: false
      }, {
        title: "Scheduled",
        blurb: "Fixed time and frequency",
        context: 'Daily at 3PM, weekly for an hour, etc...',
        id: '20-30-min',
        selected: false
      }, {
        title: "Anchored",
        blurb: "Anchor on existing habit",
        context: '5 minutes after morning coffee, after work, etc..',
        id: '1-hour',
        selected: false
      }]
    };
  },

  methods: {
    setPracticeTime: function setPracticeTime(questionID) {
      this.questions.forEach(function (question, index) {
        console.log(question);
        if (question.id === questionID) {
          question.selected = true;
        } else {
          question.selected = false;
        }
      });

      this.$store.commit('setPracticeTime', questionID);
    }
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      questions: [{
        title: "Repetiore",
        blurb: "Play your favorites",
        context: "Have great list of songs at your disposal.",
        selected: false,
        id: "important-new-songs"
      }, {
        title: "Jam",
        blurb: "Improvisation",
        context: "Play from you heart, mind, alone or with a group.",
        selected: false,
        text: '',
        id: 'important-music-concepts'
      }, {
        title: "Expansion",
        blurb: "Growth and virtuosity",
        context: "Enjoy the struggles and rewards of constant imporovement",
        selected: false,
        id: 'important-guidence'
      }]
    };
  },
  methods: {
    setGoal: function setGoal(questionID) {
      this.questions.forEach(function (question, index) {
        console.log(question);
        if (question.id === questionID) {
          question.selected = true;
        } else {
          question.selected = false;
        }
      });

      this.$store.commit('setGoal', questionID);
    }
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_battles_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    handleTrial: function handleTrial() {
      localStorage.isTry = true;
      localStorage.trialStart = new Date();
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["d" /* login */])();
    },
    handleCustomer: function handleCustomer() {
      localStorage.isTry = false;
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["d" /* login */])();
    },
    getUser: function getUser() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__utils_battles_api__["g" /* getUser */])().then(function (user) {
        // Set user
        _this.$store.commit('setUser', user);
        // if user paid, redirect to home
        // payment component also will redirect to home upon successful payment
        if (user.payment && user.payment.duration > 0) {
          // alert("paid")
          _this.$router.push({ path: 'home' });
        }
      }).catch(function (error) {
        console.log(error);
        //alert("error")
      });
    }
  },
  mounted: function mounted() {
    this.getUser();
    /*
    if (!this.isLoggedIn()) {
      alert("not logged in")
      this.handleLogin()
    }
    */
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tone__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    play: function play() {
      // create a synth and connect it to the master output (your speakers)
      var polySynth = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.PolySynth(4, __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth).toMaster();
      // play a random interval
      polySynth.triggerAttackRelease(this.randomInterval(), '2n');
    },
    randomInterval: function randomInterval() {
      var intervals = [['C4', 'E4'], ['C4', 'F4'], ['C4', 'G4'], ['C4', 'A4'], ['C4', 'B4']];

      return intervals[Math.floor(Math.random() * intervals.length)];
    }
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(77);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            rows: [0, 1, 2],
            bpm: 120,
            steps: [{
                id: 1,
                on: [false, false, false]
            }, {
                id: 2,
                on: [false, false, false]
            }, {
                id: 3,
                on: [false, false, false]
            }, {
                id: 4,
                on: [false, false, false]
            }, {
                id: 5,
                on: [false, false, false]
            }, {
                id: 6,
                on: [false, false, false]
            }, {
                id: 7,
                on: [false, false, false]
            }, {
                id: 8,
                on: [false, false, false]
            }]
        };
    },

    methods: {
        updateBPM: function updateBPM(evt) {
            this.bpm = evt.target.value;
            __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.bpm.value = this.bpm;
        },
        toggle: function toggle(id, col) {
            console.log(id, col);
            var stepButton = this.steps.find(function (s) {
                return s.id == id;
            });
            stepButton.on[col] = !stepButton.on[col];
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.steps, this.steps.indexOf(stepButton), stepButton);
        },
        stop: function stop() {
            __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.stop();
        },
        start: function start() {
            var notes = ['C4', 'Eb4', 'G4'];

            /*
            const synths = [
                new Tone.Synth(),
                new Tone.Synth(),
                new Tone.MembraneSynth()
            ]
            */

            var synths = [new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth(), new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth(), new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth()];

            synths[0].oscillatorType = 'triangle';
            synths[1].oscillatorType = 'triangle';
            synths[2].oscillatorType = 'triangle';

            synths.forEach(function (synth) {
                return synth.toMaster();
            });

            __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.scheduleRepeat(repeat, '8n');
            __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.bpm.value = this.bpm;
            __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.start();

            var index = 0;

            //view model for nested reference
            var vm = this;

            function repeat(time) {
                var step = index % 8;

                var _loop = function _loop(i) {
                    var button = vm.steps.find(function (s) {
                        return s.id == i;
                    });
                    if (step === button.id && button.on[0]) synths[0].triggerAttackRelease(notes[0], '8n', time);
                    if (step === button.id && button.on[1]) synths[1].triggerAttackRelease(notes[1], '8n', time);
                    if (step === button.id && button.on[2]) synths[2].triggerAttackRelease(notes[2], '8n', time);
                };

                for (var i = 1; i < 9; i++) {
                    _loop(i);
                }

                index++;
            }
        }
    }
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// let webaudiofont = require('webaudiofont')
// let player = new WebAudioFontPlayer()
/*
import MIDI from 'midi.js'
MIDI.loadPlugin({
  instrument: 'bassoon',
  soundfontUrl: '/static/soundfonts/',
  onsuccess: function () {
    alert('loaded')
  }
})
*/


// import * as MidiConvert from 'midiconvert'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      'showC4': true,
      'showD4': false,
      'showE4': false,
      'showF4': false,
      'showG4': false
    };
  },

  methods: {
    play: function play() {
      // MidiConvert.load('/static/midi/test.mid', function (midi) {
      fetch('/static/midi/bach.json').then(function (response) {
        var json = response.json();
        console.log(json);
        return json;
      }).then(function (midi) {
        var synth = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.PolySynth(8, __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth).toMaster();

        // make sure you set the tempo before you schedule the events
        __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.bpm.value = midi.header.bpm;

        // pass in the note events from one of the tracks as the second argument to Tone.Part
        var part = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Part(function (time, note) {
          // use the events to play the synth
          synth.triggerAttackRelease(note.name, note.duration, time, note.velocity);

          if (note.name === 'D4') {
            __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Draw.schedule(function () {
              // the callback synced to the animation frame at the given time
              this.showD4 = true;
            }, time);
          } else {}
        }, midi.tracks[1].notes); // Note, this was on Second track?

        console.log(midi);
        console.log(part);

        // start the transport to hear the events
        part.start(0);
        console.log('Tone.part: ', part.state);

        __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.start();
        console.log('Tone.Transport: ', __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport);
      });
    }
  }
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_opensheetmusicdisplay__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_opensheetmusicdisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_opensheetmusicdisplay__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    var container = document.getElementById('div-container');
    var osmd = new __WEBPACK_IMPORTED_MODULE_0_opensheetmusicdisplay__["OpenSheetMusicDisplay"](container);
    osmd.load('/static/music-xml/Sonate_No._14_Moonlight_1st_Movement.mxl').then(function () {
      osmd.render();
    });
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppNav__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_battles_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privateBattles',
  components: {
    AppNav: __WEBPACK_IMPORTED_MODULE_0__AppNav__["a" /* default */]
  },
  data: function data() {
    return {
      privateBattles: ''
    };
  },

  methods: {
    isLoggedIn: function isLoggedIn() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["c" /* isLoggedIn */])();
    },
    getPrivateStartupBattles: function getPrivateStartupBattles() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__utils_battles_api__["e" /* getPrivateStartupBattles */])().then(function (battles) {
        _this.privateBattles = battles;
      });
    }
  },
  mounted: function mounted() {
    this.getPrivateStartupBattles();
  }
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoView_vue__ = __webpack_require__(78);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-nav',
  methods: {
    handleLogin: function handleLogin() {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* login */])();
    },
    handleLogout: function handleLogout() {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["e" /* logout */])();
    },
    isLoggedIn: function isLoggedIn() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["c" /* isLoggedIn */])();
    },
    openVideo: function openVideo(step) {
      this.$store.commit('setCompletionStepForModal', step);
      this.$modal.show("historyVideoModal", {
        adaptive: true
      }, {
        width: "80%",
        height: "80%"
      });
    }
  }
});

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppNav__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_battles_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'publicBattles',
  components: {
    AppNav: __WEBPACK_IMPORTED_MODULE_0__AppNav__["a" /* default */]
  },
  data: function data() {
    return {
      publicBattles: ''
    };
  },

  methods: {
    isLoggedIn: function isLoggedIn() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["c" /* isLoggedIn */])();
    },
    getPublicStartupBattles: function getPublicStartupBattles() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__utils_battles_api__["f" /* getPublicStartupBattles */])().then(function (battles) {
        _this.publicBattles = battles;
      });
    }
  },
  mounted: function mounted() {
    this.getPublicStartupBattles();
  }
});

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_battles_api__ = __webpack_require__(17);
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    handleLogin: function handleLogin() {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* login */])();
    },
    isLoggedIn: function isLoggedIn() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["c" /* isLoggedIn */])();
    }
  },
  mounted: function mounted() {
    // if client thinks i'm not logged in
    if (!this.isLoggedIn()) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* login */])();
    } else {
      // There is the change the client things it's logged in,
      // but isn't on server.
      this.$router.push({ path: 'home' });
    }
  }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(26);
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  mounted: function mounted() {
    this.$nextTick(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["g" /* setAccessToken */])();
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["h" /* setIdToken */])();
      window.location.href = '/app.html#/';
    });
  }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__ = __webpack_require__(338);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 799px;\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n'], ['\n  width: 799px;\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 30px;\n  line-height: 36px;\n  padding-top: 6.2vh;\n  margin-block-end: 12px; // hack?\n\n  color: #000000;\n'], ['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 30px;\n  line-height: 36px;\n  padding-top: 6.2vh;\n  margin-block-end: 12px; // hack?\n\n  color: #000000;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  // width: 90%;\n  height: 191px;\n  background: #FFFFFF;\n  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.11);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-left: 21px;\n  margin-bottom: 12px;\n\n  @media (max-width: 600px) {\n    padding-left: 10px;\n  }\n'], ['\n  // width: 90%;\n  height: 191px;\n  background: #FFFFFF;\n  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.11);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-left: 21px;\n  margin-bottom: 12px;\n\n  @media (max-width: 600px) {\n    padding-left: 10px;\n  }\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n\n  width: 118px;\n  height: 35px;\n  cursor: pointer; \n\n  font-family: \'Roboto\', sans-serif;\n  font-size: 11px;\n  line-height: 13px;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: #FFFFFF;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  background: #FF006B;\n  border-radius: 3px;\n\n  @media (max-width: 600px) {\n    width: 69px;\n    height: 27px;\n  }\n\n'], ['\n\n  width: 118px;\n  height: 35px;\n  cursor: pointer; \n\n  font-family: \'Roboto\', sans-serif;\n  font-size: 11px;\n  line-height: 13px;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: #FFFFFF;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  background: #FF006B;\n  border-radius: 3px;\n\n  @media (max-width: 600px) {\n    width: 69px;\n    height: 27px;\n  }\n\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: \'Roboto\', sans-serif;\n  // padding-bottom: 69px;\n  padding-bottom: 9vh;\n  font-size: 36px;\n  line-height: 108.7%;\n  /* or 39px */\n  text-align: center;\n  color: #000000;\n'], ['\n  font-family: \'Roboto\', sans-serif;\n  // padding-bottom: 69px;\n  padding-bottom: 9vh;\n  font-size: 36px;\n  line-height: 108.7%;\n  /* or 39px */\n  text-align: center;\n  color: #000000;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  //padding-top: 92px;\n  padding-top: 12vh;\n'], ['\n  //padding-top: 92px;\n  padding-top: 12vh;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10vw;\n  padding-bottom: 14vh;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10vw;\n  padding-bottom: 14vh;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 25vw;\n  cursor: pointer;\n\n  @media (max-width: 600px) {\n    width: 90%;\n  }\n\n  height: 150px;\n\n  padding-top: 34px;\n  padding: 40px;\n  margin: 10px;\n  background: #FFFFFF;\n\n  box-shadow: 0 3px 3px rgba(0,0,0,0.2);\n  border: ', ';\n\n  display: flex;\n  flex-direction: column;\n\n  justify-content: space-between;\n\n  text-align: center;\n'], ['\n  width: 25vw;\n  cursor: pointer;\n\n  @media (max-width: 600px) {\n    width: 90%;\n  }\n\n  height: 150px;\n\n  padding-top: 34px;\n  padding: 40px;\n  margin: 10px;\n  background: #FFFFFF;\n\n  box-shadow: 0 3px 3px rgba(0,0,0,0.2);\n  border: ', ';\n\n  display: flex;\n  flex-direction: column;\n\n  justify-content: space-between;\n\n  text-align: center;\n']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 12px;\n  line-height: 108.7%;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  font-weight: bold;\n  color: #FF006B;\n'], ['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 12px;\n  line-height: 108.7%;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  font-weight: bold;\n  color: #FF006B;\n']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 21px;\n  line-height: 108.7%;\n  /* or 23px */\n  color: #000000;\n'], ['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 21px;\n  line-height: 108.7%;\n  /* or 23px */\n  color: #000000;\n']),
    _templateObject12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 16px;\n  line-height: 108.7%;\n  /* or 17px */\n  text-align: center;\n  color: #444444;\n'], ['\n  font-family: \'Roboto\', sans-serif;\n  font-size: 16px;\n  line-height: 108.7%;\n  /* or 17px */\n  text-align: center;\n  color: #444444;\n']),
    _templateObject13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n\n  width: 195px;\n  height: 60px;\n  cursor: pointer;\n\n  background: ', ';\n\n  border-radius: 3px;\n  margin: 10px;\n\n  font-family: \'Roboto\', sans-serif;\n  font-size: 16px;\n  line-height: 19px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.15em;\n  color: #FFFFFF;\n\n  @media (max-width: 600px) {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: ', ';\n    margin: 0px;\n  }\n'], ['\n\n  width: 195px;\n  height: 60px;\n  cursor: pointer;\n\n  background: ', ';\n\n  border-radius: 3px;\n  margin: 10px;\n\n  font-family: \'Roboto\', sans-serif;\n  font-size: 16px;\n  line-height: 19px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.15em;\n  color: #FFFFFF;\n\n  @media (max-width: 600px) {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: ', ';\n    margin: 0px;\n  }\n']),
    _templateObject14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid white;\n  padding: 10px;\n\n'], ['\n  border: 1px solid white;\n  padding: 10px;\n\n']),
    _templateObject15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 4em;\n  background: ', ';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  width: 60%;\n  color: white;\n'], ['\n  padding: 4em;\n  background: ', ';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  width: 60%;\n  color: white;\n']),
    _templateObject16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: #c3375b;\n  color: white;\n  padding: 20px;\n  border-radius: 10px;\n'], ['\n  background-color: #c3375b;\n  color: white;\n  padding: 20px;\n  border-radius: 10px;\n']);



var ContentFrame = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject);

var CenterWrapper = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject2);

var PageTitle = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].h1(_templateObject3);

var LessonCard = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject4);

var LessonCTA = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject5);

var QuestionTitle = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].h1(_templateObject6);
var QuestionWrapper = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject7);
var ChoicesWrapper = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject8);
var Choice = Object(__WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */])('div', { selected: Boolean })(_templateObject9, function (props) {
  return props.selected ? '7px solid #FF1074;' : 'none;';
});

var ChoiceTitle = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject10);
var ChoiceBlurb = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject11);
var ChoiceContext = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject12);

var ChoiceConfirm = Object(__WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */])('div', { disabled: Boolean })(_templateObject13, function (props) {
  return props.disabled ? 'rgba(255, 0, 107, 0.2);' : '#FF006B';
}, function (props) {
  return props.disabled ? '#FF006B' : '#FF006B';
});

// 92 from top, 69 to bottom

var Selectable = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].div(_templateObject14);
// Create a <Wrapper> Vue component that renders a <section> with
// some padding and a papayawhip background
var Box = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].section(_templateObject15, function (props) {
  return props.theme.background;
});

var CTA = __WEBPACK_IMPORTED_MODULE_1_vue_styled_components__["b" /* default */].button(_templateObject16);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {

    /* todo junk */
    'box': Box,
    'cta': CTA,
    'selectable': Selectable,
    /* end junk */

    'QuestionTitle': QuestionTitle,
    'QuestionWrapper': QuestionWrapper,
    'ChoicesWrapper': ChoicesWrapper,
    'Choice': Choice,
    'ChoiceTitle': ChoiceTitle,
    'ChoiceBlurb': ChoiceBlurb,
    'ChoiceContext': ChoiceContext,
    'ChoiceConfirm': ChoiceConfirm,

    'PageTitle': PageTitle,
    'CenterWrapper': CenterWrapper,
    'ContentFrame': ContentFrame,
    'LessonCard': LessonCard,
    'LessonCTA': LessonCTA
  }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_UI__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Chart__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppNav__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Practice__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_styled_components__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_battles_api__ = __webpack_require__(17);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











// TODO rename battles-api






// Vue.use(Vuefire)
// TODO: no need for Vueresource and Axios ?
// Vue.use(Vueresource)
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default.a, {
  dynamic: true,
  adaptive: true,
  dynamicDefaults: {
    clickToClose: false
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

// Component Definitions

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('LessonCTA', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.LessonCTA);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('LessonCard', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.LessonCard);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('ContentFrame', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.ContentFrame);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('CenterWrapper', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.CenterWrapper);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('PageTitle', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.PageTitle);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('QuestionTitle', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.QuestionTitle);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('QuestionWrapper', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.QuestionWrapper);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('ChoicesWrapper', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.ChoicesWrapper);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('Choice', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.Choice);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('ChoiceTitle', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.ChoiceTitle);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('ChoiceBlurb', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.ChoiceBlurb);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('ChoiceContext', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.ChoiceContext);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('ChoiceConfirm', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.ChoiceConfirm);

// junk
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('selectable', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.selectable);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('box', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.box);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('cta', __WEBPACK_IMPORTED_MODULE_5__ui_UI__["a" /* default */].components.cta);

// chart
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('practice', __WEBPACK_IMPORTED_MODULE_8__components_Practice__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('chart', __WEBPACK_IMPORTED_MODULE_6__components_Chart__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('BurgerNav', __WEBPACK_IMPORTED_MODULE_7__components_AppNav__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('theme-provider', __WEBPACK_IMPORTED_MODULE_9_vue_styled_components__["a" /* ThemeProvider */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    step: {},
    // TODO This should be moved into user object
    preference: {
      lookingFor: '',
      practiceTime: '',
      goal: ''
    },
    user: {},
    completions: [],
    completionStepForModal: null
  },
  getters: {

    // TODO sort of a hack, best if this is in some central location
    // steps and validation
    onboardingNextDisabled: function onboardingNextDisabled(state) {
      return function (step) {
        if (step == 0 && state.preference.lookingFor != '') {
          return false;
        }

        if (step == 1 && state.preference.practiceTime !== '') {
          return false;
        }

        if (step == 2 && state.preference.goal !== '') {
          return false;
        }

        return true;
      };
    }
  },
  mutations: {
    setCompletionStepForModal: function setCompletionStepForModal(state, step) {
      state.completionStepForModal = step;
    },
    setUser: function setUser(state, user) {
      // console.log("setting user", user)
      state.user = user;
    },
    getNextStep: function getNextStep(state) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_battles_api__["c" /* getNextStep */])().then(function (step) {
        state.step = step;
      });
    },
    getCompletions: function getCompletions(state) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_battles_api__["b" /* getCompletions */])().then(function (completions) {
        state.completions = completions;
      });
    },
    completeStep: function completeStep(state, step) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_battles_api__["a" /* completeStep */])(step).then(function (step) {
        state.step = step;
      });
    },
    previousStep: function previousStep(state, step) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_battles_api__["i" /* previousStep */])(step).then(function (step) {
        state.step = step;
      });
    },
    setChain: function setChain(state, decision) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_battles_api__["k" /* setChain */])(decision).then(function (step) {
        state.step = step;
      });
    },


    //Onboarding
    setLookingFor: function setLookingFor(state, questionID) {
      state.preference.lookingFor = questionID;
    },
    setPracticeTime: function setPracticeTime(state, questionID) {
      state.preference.practiceTime = questionID;
    },
    setGoal: function setGoal(state, questionID) {
      state.preference.goal = questionID;
    },


    // save all onboarding prefs
    setPreference: function setPreference(state, choices) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_battles_api__["l" /* setPreference */])(choices).then(function (user) {
        console.log("setting user");

        // If user selected trial, redirect home
        if (JSON.parse(localStorage.isTry) === true) {
          __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ path: 'home' });
        }

        state.user = user;
      });
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: store,
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    // arrow functions can make the code very succinct!
    step: function step(state) {
      return state.step;
    },

    // passing the string value 'count' is same as `state => state.count`
    stepAlias: 'step',
    //Static global???
    name: function name(_name) {
      return state.name;
    },

    nameAlias: 'name',

    user: function user(state) {
      return state.user;
    },

    preference: function preference(state) {
      return state.preference;
    }

  }, 'nameAlias', 'preference'))
});

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6d8df98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6d8df98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6d8df98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryVideoView_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2794f9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryVideoView_vue__ = __webpack_require__(359);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2794f9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryVideoView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2794f9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryVideoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wistia_responsive_padding",staticStyle:{"padding":"56.25% 0 0 0","position":"relative"}},[_c('div',{staticClass:"wistia_responsive_wrapper",staticStyle:{"height":"100%","left":"0","position":"absolute","top":"0","width":"100%"}},[_c('div',{class:_vm.wrapperClass,staticStyle:{"height":"100%","position":"relative","width":"100%"}},[_c('div',{staticClass:"wistia_swatch",staticStyle:{"height":"100%","left":"0","opacity":"0","overflow":"hidden","position":"absolute","top":"0","transition":"opacity 200ms","width":"100%"}},[_c('img',{staticStyle:{"filter":"blur(5px)","height":"100%","object-fit":"contain","width":"100%"},attrs:{"src":_vm.imgValue,"alt":"","onload":"this.parentNode.style.opacity=1;"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('theme-provider',{attrs:{"theme":this.theme}},[_c('div',{staticClass:"nav"},[_c('div',{staticClass:"navLeft"},[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/static/landing/assets/black-logo-transparent.png","width":"180"}})])]),_vm._v(" "),_c('div',{class:_vm.modalMenuClasses},[_c('BurgerNav')],1),_vm._v(" "),_c('div',{class:_vm.menuClasses,attrs:{"type":"button"},on:{"click":_vm.toggleMenu}},[_c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])])]),_vm._v(" "),_c('div',{staticClass:"mainWrapper"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"footerWrap"}),_vm._v(" "),_c('modals-container'),_vm._v(" "),_c('modal',{attrs:{"width":"80%","height":"80%","name":"historyVideoModal"}},[_c(this.historyVideoView,{tag:"component"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeView__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Begin__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Plan__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Practice__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_IntervalView__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MetronomeView__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PlayerView__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_onboarding_OnboardingView__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_VideoView__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NotationView__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DesignSystemView__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_privateBattles__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_publicBattles__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Login__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Payment__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_callback__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_auth__ = __webpack_require__(26);



// Components




// import DetailView from '@/components/DetailView'
// import PostView from '@/components/PostView'








// Auth0 tutorial







// Auth helpers


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'begin',
    // beforeEnter: requireAuth,
    component: __WEBPACK_IMPORTED_MODULE_3__components_Begin__["a" /* default */]
  }, {
    path: '/plan',
    name: 'plan',
    // beforeEnter: requireAuth,
    component: __WEBPACK_IMPORTED_MODULE_4__components_Plan__["a" /* default */]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Login__["a" /* default */]
  }, {
    path: '/practice',
    name: 'practice',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Practice__["a" /* default */]
  }, {
    path: '/home',
    name: 'home',
    // beforeEnter: requireAuth,
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeView__["a" /* default */]
  },
  /* JUNK old firebase POC
  {
    path: '/detail/:id',
    name: 'detail',
    component: DetailView
  },
  {
    path: '/post',
    name: 'post',
    component: PostView
  },
  */
  {
    path: '/metronome',
    name: 'metronome',
    component: __WEBPACK_IMPORTED_MODULE_7__components_MetronomeView__["a" /* default */]
  }, {
    path: '/onboard',
    name: 'onboard',
    // beforeEnter: requireAuth,
    component: __WEBPACK_IMPORTED_MODULE_9__components_onboarding_OnboardingView__["a" /* default */]
  }, {
    path: '/interval',
    name: 'interval',
    component: __WEBPACK_IMPORTED_MODULE_6__components_IntervalView__["a" /* default */]
  }, {
    path: '/player',
    name: 'player',
    component: __WEBPACK_IMPORTED_MODULE_8__components_PlayerView__["a" /* default */]
  }, {
    path: '/video',
    name: 'video',
    component: __WEBPACK_IMPORTED_MODULE_10__components_VideoView__["a" /* default */]
  }, {
    path: '/notation',
    name: 'notation',
    component: __WEBPACK_IMPORTED_MODULE_11__components_NotationView__["a" /* default */]
  }, {
    path: '/design',
    name: 'design',
    component: __WEBPACK_IMPORTED_MODULE_12__components_DesignSystemView__["a" /* default */]
  }, {
    path: '/public-battles',
    name: 'PublicBattles',
    component: __WEBPACK_IMPORTED_MODULE_14__components_publicBattles__["a" /* default */]
  }, {
    path: '/payment',
    // beforeEnter: requireAuth,
    name: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Payment__["a" /* default */]
  }, {
    path: '/private-battles',
    name: 'PrivateBattles',
    beforeEnter: __WEBPACK_IMPORTED_MODULE_18__utils_auth__["f" /* requireAuth */],
    component: __WEBPACK_IMPORTED_MODULE_13__components_privateBattles__["a" /* default */]
  }, {
    path: '/callback',
    component: __WEBPACK_IMPORTED_MODULE_17__components_callback__["a" /* default */]
  }]
}));

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeView_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dd2c1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeView_vue__ = __webpack_require__(578);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60dd2c1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dd2c1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  pictures: [{
    'id': 0,
    'url': 'https://25.media.tumblr.com/tumblr_m40h4ksiUa1qbyxr0o1_400.gif',
    'comment': 'A cat game',
    'info': 'Posted by Kevin on Friday'
  }, {
    'id': 1,
    'url': 'https://25.media.tumblr.com/tumblr_lhd7n9Qec01qgnva2o1_500.jpg',
    'comment': 'Tatoo & cat',
    'info': 'Posted by Charles on Tuesday'
  }, {
    'id': 2,
    'url': 'https://24.media.tumblr.com/tumblr_m4j2atctRm1qejbiro1_1280.jpg',
    'comment': 'Santa cat',
    'info': 'Posted by Richard on Monday'
  }, {
    'id': 3,
    'url': 'https://25.media.tumblr.com/tumblr_m3rmbwhVB51qhwmnpo1_1280.jpg',
    'comment': 'Mexico cat',
    'info': 'Posted by Richard on Monday'
  }, {
    'id': 4,
    'url': 'https://24.media.tumblr.com/tumblr_mceknxs4Lo1qd477zo1_500.jpg',
    'comment': 'Curious cat',
    'info': 'Posted by Richard on Monday'
  }]
});

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wistia_responsive_padding",staticStyle:{"padding":"56.25% 0 0 0","position":"relative"}},[_c('div',{staticClass:"wistia_responsive_wrapper",staticStyle:{"height":"100%","left":"0","position":"absolute","top":"0","width":"100%"}},[_c('div',{class:_vm.wrapperClass,staticStyle:{"height":"100%","position":"relative","width":"100%"}},[_c('div',{staticClass:"wistia_swatch",staticStyle:{"height":"100%","left":"0","opacity":"0","overflow":"hidden","position":"absolute","top":"0","transition":"opacity 200ms","width":"100%"}},[_c('img',{staticStyle:{"filter":"blur(5px)","height":"100%","object-fit":"contain","width":"100%"},attrs:{"src":_vm.imgValue,"alt":"","onload":"this.parentNode.style.opacity=1;"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 127,
	"./af.js": 127,
	"./ar": 128,
	"./ar-dz": 129,
	"./ar-dz.js": 129,
	"./ar-kw": 130,
	"./ar-kw.js": 130,
	"./ar-ly": 131,
	"./ar-ly.js": 131,
	"./ar-ma": 132,
	"./ar-ma.js": 132,
	"./ar-sa": 133,
	"./ar-sa.js": 133,
	"./ar-tn": 134,
	"./ar-tn.js": 134,
	"./ar.js": 128,
	"./az": 135,
	"./az.js": 135,
	"./be": 136,
	"./be.js": 136,
	"./bg": 137,
	"./bg.js": 137,
	"./bm": 138,
	"./bm.js": 138,
	"./bn": 139,
	"./bn.js": 139,
	"./bo": 140,
	"./bo.js": 140,
	"./br": 141,
	"./br.js": 141,
	"./bs": 142,
	"./bs.js": 142,
	"./ca": 143,
	"./ca.js": 143,
	"./cs": 144,
	"./cs.js": 144,
	"./cv": 145,
	"./cv.js": 145,
	"./cy": 146,
	"./cy.js": 146,
	"./da": 147,
	"./da.js": 147,
	"./de": 148,
	"./de-at": 149,
	"./de-at.js": 149,
	"./de-ch": 150,
	"./de-ch.js": 150,
	"./de.js": 148,
	"./dv": 151,
	"./dv.js": 151,
	"./el": 152,
	"./el.js": 152,
	"./en-SG": 153,
	"./en-SG.js": 153,
	"./en-au": 154,
	"./en-au.js": 154,
	"./en-ca": 155,
	"./en-ca.js": 155,
	"./en-gb": 156,
	"./en-gb.js": 156,
	"./en-ie": 157,
	"./en-ie.js": 157,
	"./en-il": 158,
	"./en-il.js": 158,
	"./en-nz": 159,
	"./en-nz.js": 159,
	"./eo": 160,
	"./eo.js": 160,
	"./es": 161,
	"./es-do": 162,
	"./es-do.js": 162,
	"./es-us": 163,
	"./es-us.js": 163,
	"./es.js": 161,
	"./et": 164,
	"./et.js": 164,
	"./eu": 165,
	"./eu.js": 165,
	"./fa": 166,
	"./fa.js": 166,
	"./fi": 167,
	"./fi.js": 167,
	"./fo": 168,
	"./fo.js": 168,
	"./fr": 169,
	"./fr-ca": 170,
	"./fr-ca.js": 170,
	"./fr-ch": 171,
	"./fr-ch.js": 171,
	"./fr.js": 169,
	"./fy": 172,
	"./fy.js": 172,
	"./ga": 173,
	"./ga.js": 173,
	"./gd": 174,
	"./gd.js": 174,
	"./gl": 175,
	"./gl.js": 175,
	"./gom-latn": 176,
	"./gom-latn.js": 176,
	"./gu": 177,
	"./gu.js": 177,
	"./he": 178,
	"./he.js": 178,
	"./hi": 179,
	"./hi.js": 179,
	"./hr": 180,
	"./hr.js": 180,
	"./hu": 181,
	"./hu.js": 181,
	"./hy-am": 182,
	"./hy-am.js": 182,
	"./id": 183,
	"./id.js": 183,
	"./is": 184,
	"./is.js": 184,
	"./it": 185,
	"./it-ch": 186,
	"./it-ch.js": 186,
	"./it.js": 185,
	"./ja": 187,
	"./ja.js": 187,
	"./jv": 188,
	"./jv.js": 188,
	"./ka": 189,
	"./ka.js": 189,
	"./kk": 190,
	"./kk.js": 190,
	"./km": 191,
	"./km.js": 191,
	"./kn": 192,
	"./kn.js": 192,
	"./ko": 193,
	"./ko.js": 193,
	"./ku": 194,
	"./ku.js": 194,
	"./ky": 195,
	"./ky.js": 195,
	"./lb": 196,
	"./lb.js": 196,
	"./lo": 197,
	"./lo.js": 197,
	"./lt": 198,
	"./lt.js": 198,
	"./lv": 199,
	"./lv.js": 199,
	"./me": 200,
	"./me.js": 200,
	"./mi": 201,
	"./mi.js": 201,
	"./mk": 202,
	"./mk.js": 202,
	"./ml": 203,
	"./ml.js": 203,
	"./mn": 204,
	"./mn.js": 204,
	"./mr": 205,
	"./mr.js": 205,
	"./ms": 206,
	"./ms-my": 207,
	"./ms-my.js": 207,
	"./ms.js": 206,
	"./mt": 208,
	"./mt.js": 208,
	"./my": 209,
	"./my.js": 209,
	"./nb": 210,
	"./nb.js": 210,
	"./ne": 211,
	"./ne.js": 211,
	"./nl": 212,
	"./nl-be": 213,
	"./nl-be.js": 213,
	"./nl.js": 212,
	"./nn": 214,
	"./nn.js": 214,
	"./pa-in": 215,
	"./pa-in.js": 215,
	"./pl": 216,
	"./pl.js": 216,
	"./pt": 217,
	"./pt-br": 218,
	"./pt-br.js": 218,
	"./pt.js": 217,
	"./ro": 219,
	"./ro.js": 219,
	"./ru": 220,
	"./ru.js": 220,
	"./sd": 221,
	"./sd.js": 221,
	"./se": 222,
	"./se.js": 222,
	"./si": 223,
	"./si.js": 223,
	"./sk": 224,
	"./sk.js": 224,
	"./sl": 225,
	"./sl.js": 225,
	"./sq": 226,
	"./sq.js": 226,
	"./sr": 227,
	"./sr-cyrl": 228,
	"./sr-cyrl.js": 228,
	"./sr.js": 227,
	"./ss": 229,
	"./ss.js": 229,
	"./sv": 230,
	"./sv.js": 230,
	"./sw": 231,
	"./sw.js": 231,
	"./ta": 232,
	"./ta.js": 232,
	"./te": 233,
	"./te.js": 233,
	"./tet": 234,
	"./tet.js": 234,
	"./tg": 235,
	"./tg.js": 235,
	"./th": 236,
	"./th.js": 236,
	"./tl-ph": 237,
	"./tl-ph.js": 237,
	"./tlh": 238,
	"./tlh.js": 238,
	"./tr": 239,
	"./tr.js": 239,
	"./tzl": 240,
	"./tzl.js": 240,
	"./tzm": 241,
	"./tzm-latn": 242,
	"./tzm-latn.js": 242,
	"./tzm.js": 241,
	"./ug-cn": 243,
	"./ug-cn.js": 243,
	"./uk": 244,
	"./uk.js": 244,
	"./ur": 245,
	"./ur.js": 245,
	"./uz": 246,
	"./uz-latn": 247,
	"./uz-latn.js": 247,
	"./uz.js": 246,
	"./vi": 248,
	"./vi.js": 248,
	"./x-pseudo": 249,
	"./x-pseudo.js": 249,
	"./yo": 250,
	"./yo.js": 250,
	"./zh-cn": 251,
	"./zh-cn.js": 251,
	"./zh-hk": 252,
	"./zh-hk.js": 252,
	"./zh-tw": 253,
	"./zh-tw.js": 253
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 374;

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('chart')],1),_vm._v(" "),_c('div',[_c('page-title',[_vm._v("Track your practice!")]),_vm._v(" "),_vm._l((_vm.practiceLengths),function(option){return _c('selectable',{key:option.minutes,on:{"click":function($event){_vm.setOption(option.minutes)}}},[_vm._v("\n      "+_vm._s(option.label)+"\n    ")])}),_vm._v(" "),_c('textarea',{directives:[{name:"mode",rawName:"v-mode",value:(_vm.notes),expression:"notes"}],attrs:{"placeholder":"enter notes (optional)"}}),_vm._v(" "),_c('cta',{on:{"click":_vm.save}},[_vm._v("Save")])],2),_vm._v(" "),_c('div',_vm._l((_vm.sessions),function(session){return _c('div',[_vm._v("\n      "+_vm._s(session.minutes)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CenterWrapper',[_c('ContentFrame',[_c('PageTitle',[_vm._v("\n      Next\n    ")]),_vm._v(" "),_c('div',{staticClass:"progressTitle"},[_vm._v("progress")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_vm._l((_vm.$store.state.completions.length),function(n){return _c('div',{staticClass:"progressChunk progressCompleted"})}),_vm._v(" "),_vm._l(((250 - _vm.$store.state.completions.length)),function(n){return _c('div',{staticClass:"progressChunk progressIncomplete"})})],2),_vm._v(" "),(_vm.$store.state.step.type == 'video')?_c('div',[_c('LessonCard',[_c('div',{staticClass:"videoThumbContainer",style:({ backgroundImage: ("url(" + (_vm.$store.state.step.thumbnail) + ")") })}),_vm._v(" "),_c('div',{staticClass:"videoInfo"},[_c('div',{staticClass:"videoTitle"},[_vm._v("\n            "+_vm._s(_vm.$store.state.step.name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n            "+_vm._s(_vm.$store.state.step.description)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"videoMeta"})]),_vm._v(" "),_c('div',{staticClass:"ctaStepContainer"},[_c('LessonCTA',{on:{"click":_vm.open}},[_c('div',[_vm._v("Start")])]),_vm._v(" "),_c('LessonCTA',{on:{"click":_vm.completeStep}},[_c('div',[_vm._v("Done")])]),_vm._v(" "),_c('div',{staticClass:"videoStep"})],1)])],1):(_vm.$store.state.step.type == 'reflection')?_c('div',[_c('div',{staticClass:"demo-card-event mdl-card mdl-shadow--2dp"},[_c('h4',[_vm._v("\n          "+_vm._s(_vm.$store.state.step.description)+"\n        ")]),_vm._v(" "),_c('ul',{attrs:{"id":"answers"}},_vm._l((_vm.$store.state.step.stepMeta.qandA),function(item){return _c('div',[_vm._v("\n            "+_vm._s(item.question)+"\n            "),_vm._l((item.choices),function(choice){return _c('li',[_c('button',{attrs:{"type":"checkbox"},on:{"click":function($event){_vm.checkAnswer(choice , item.rightAns)}}},[_vm._v("\n                "+_vm._s(choice)+"\n              ")])])})],2)})),_vm._v(" "),_c('a',{staticClass:"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":_vm.completeStep}},[_vm._v("\n          Done\n          "),_c('i',{staticClass:"material-icons"},[_vm._v("check_circle_outline")])])])]):(_vm.$store.state.step.type == 'decision')?_c('div',_vm._l((_vm.$store.state.step.stepMeta.decisions),function(decision){return _c('LessonCard',[_c('div',{staticClass:"videoThumbContainer",style:({ backgroundImage: ("url(" + (decision.thumbnail) + ")") })}),_vm._v(" "),_c('div',{staticClass:"videoInfo"},[_c('div',{staticClass:"videoTitle"},[_vm._v("\n          "+_vm._s(decision.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n          "+_vm._s(decision.description)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"videoMeta"},[_c('div',[_vm._v(_vm._s(decision.estimatedTime))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(decision.numberOfSteps)+"  Lessons")])])]),_vm._v(" "),_c('div',{staticClass:"ctaDecisionContainer"},[_c('LessonCTA',{on:{"click":function($event){_vm.setChain(decision)}}},[_c('div',[_vm._v("Begin")])])],1)])})):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Begin_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47bc556f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Begin_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47bc556f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Begin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47bc556f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Begin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paymentWrapper"},[_c('div',{staticClass:"paymentBox"},[_c('div',{staticClass:"header"},[_vm._v("\n      Payment\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"paymentContainer"},[_c('card',{staticClass:"stripeElements",class:{ complete: _vm.complete },attrs:{"stripe":_vm.stripeKey,"options":_vm.stripeOptions},on:{"change":function($event){_vm.complete = $event.complete}}}),_vm._v(" "),(_vm.isPaying)?_c('div',[_c('img',{attrs:{"src":"/static/img/icons/spinner-200px.gif"}})]):_vm._e(),_vm._v(" "),(!_vm.isPaying)?_c('ChoiceConfirm',{style:({ width: '100%'}),attrs:{"disabled":!_vm.complete,"id":"pay-button"},on:{"click":_vm.pay}},[_vm._v("\n      Pay Now\n      ")]):_vm._e(),_vm._v(" "),_vm._m(1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary"},[_c('div',{staticClass:"price"},[_vm._v("\n        $29\n      ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_c('div',{staticClass:"line-item"},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#FF006B","font-size":"15px"}},[_vm._v("\n            check_circle\n          ")]),_vm._v(" "),_c('div',{staticClass:"line-item__text"},[_vm._v("3 Months Access")])]),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#FF006B","font-size":"15px"}},[_vm._v("\n            check_circle\n          ")]),_vm._v(" "),_c('div',{staticClass:"line-item__text"},[_vm._v("Unlimited lesson support")])]),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#FF006B","font-size":"15px"}},[_vm._v("\n            check_circle\n          ")]),_vm._v(" "),_c('div',{staticClass:"line-item__text"},[_vm._v("30-Day Money-Back Guarantee")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stripeIcon"},[_c('img',{attrs:{"src":"/static/img/icons/powered_by_stripe.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a0e36a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__(587);
function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70a0e36a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a0e36a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuestionWrapper',[_c('QuestionTitle',[_vm._v("\n      What best describes you?\n    ")]),_vm._v(" "),_c('ChoicesWrapper',_vm._l((_vm.questions),function(question){return _c('Choice',{attrs:{"selected":question.selected},on:{"click":function($event){_vm.setLookingFor(question.id)}}},[_c('ChoiceTitle',[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('ChoiceBlurb',[_vm._v(_vm._s(question.blurb))]),_vm._v(" "),_c('ChoiceContext',[_vm._v(_vm._s(question.context))])],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question2_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6946bad0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question2_vue__ = __webpack_require__(590);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6946bad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6946bad0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuestionWrapper',[_c('QuestionTitle',[_vm._v("\n    Select a practice style...\n  ")]),_vm._v(" "),_c('ChoicesWrapper',_vm._l((_vm.questions),function(question){return _c('Choice',{attrs:{"selected":question.selected},on:{"click":function($event){_vm.setPracticeTime(question.id)}}},[_c('ChoiceTitle',[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('ChoiceBlurb',[_vm._v(_vm._s(question.blurb))]),_vm._v(" "),_c('ChoiceContext',[_vm._v(_vm._s(question.context))])],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question3_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf14191c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question3_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf14191c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf14191c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuestionWrapper',[_c('QuestionTitle',[_vm._v("\n    Imagine the future, what's most important?\n  ")]),_vm._v(" "),_c('ChoicesWrapper',_vm._l((_vm.questions),function(question){return _c('Choice',{attrs:{"selected":question.selected},on:{"click":function($event){_vm.setGoal(question.id)}}},[_c('ChoiceTitle',[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('ChoiceBlurb',[_vm._v(_vm._s(question.blurb))]),_vm._v(" "),_c('ChoiceContext',[_vm._v(_vm._s(question.context))])],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(this.currentComponent,{tag:"component"}),_vm._v(" "),_c('div',{staticClass:"ctaWrapper"},[_c('ChoiceConfirm',{attrs:{"disabled":this.$store.getters.onboardingNextDisabled(this.step)},on:{"click":_vm.increment}},[_vm._v("\n      NEXT\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoggedIn()),expression:"!isLoggedIn()"}]},[_c('QuestionWrapper',[_c('QuestionTitle',[_vm._v("\n          Welcome! Let's get started.\n        ")]),_vm._v(" "),_c('ChoicesWrapper',[_c('Choice',{attrs:{"id":"trial-select"},on:{"click":function($event){_vm.handleTrial()}}},[_c('ChoiceTitle',[_vm._v("Try it")]),_vm._v(" "),_c('ChoiceBlurb',[_vm._v("Free 1 Day Pass")]),_vm._v(" "),_c('ChoiceContext',[_vm._v("See how you like it")])],1),_vm._v(" "),_c('Choice',{attrs:{"id":"pay-select"},on:{"click":function($event){_vm.handleCustomer()}}},[_c('ChoiceTitle',[_vm._v("Ready")]),_vm._v(" "),_c('ChoiceBlurb',[_vm._v("3 Months Access w/ Unlimited Support")]),_vm._v(" "),_c('ChoiceContext',[_vm._v("$29 (money back guarantee)")])],1)],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOnboarding()),expression:"showOnboarding()"}]},[_c(this.onboardingComponent,{tag:"component"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPayment()),expression:"showPayment()"}]},[_c(this.paymentComponent,{tag:"component"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5503d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__ = __webpack_require__(598);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a5503d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5503d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QuestionWrapper',[_c('QuestionTitle',[_vm._v("\n          Welcome! Let's get started.\n        ")]),_vm._v(" "),_c('ChoicesWrapper',[_c('Choice',{attrs:{"id":"trial-select"},on:{"click":function($event){_vm.handleTrial()}}},[_c('ChoiceTitle',[_vm._v("Try it")]),_vm._v(" "),_c('ChoiceBlurb',[_vm._v("Free 1 Day Pass")]),_vm._v(" "),_c('ChoiceContext',[_vm._v("See how you like it")])],1),_vm._v(" "),_c('Choice',{attrs:{"id":"pay-select"},on:{"click":function($event){_vm.handleCustomer()}}},[_c('ChoiceTitle',[_vm._v("Ready")]),_vm._v(" "),_c('ChoiceBlurb',[_vm._v("3 Months Access w/ Unlimited Support")]),_vm._v(" "),_c('ChoiceContext',[_vm._v("$29 w/ 30 Day Money Back Guarantee")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntervalView_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95363eec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntervalView_vue__ = __webpack_require__(600);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntervalView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95363eec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntervalView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Play a random interval")]),_vm._v(" "),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.play($event)}}},[_vm._v("\n      Play\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MetronomeView_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6ec9fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetronomeView_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b6ec9fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MetronomeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6ec9fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetronomeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wrapper',[_c('styled-title',[_vm._v("Arpegiator!")]),_vm._v(" "),_c('div',[_vm._v("("+_vm._s(_vm.bpm)+" BPM's)")]),_vm._v(" "),_c('input',{staticClass:"mdl-slider mdl-js-slider",attrs:{"type":"range","min":"50","max":"180","tabindex":"0"},domProps:{"value":_vm.bpm},on:{"input":function($event){_vm.updateBPM($event)}}}),_vm._v(" "),_c('button',{on:{"click":_vm.start}},[_vm._v("Start")]),_vm._v(" "),_c('button',{on:{"click":_vm.stop}},[_vm._v("Stop")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.rows),function(row){return _c('div',{staticClass:"column"},_vm._l((_vm.steps),function(step){return _c('div',{key:step.id + '-' + row},[(step.on[row] === true)?_c('button',{staticClass:"toggled",on:{"click":function($event){_vm.toggle(step.id, row)}}},[_vm._v(_vm._s(step.id))]):_c('button',{staticClass:"untoggled",on:{"click":function($event){_vm.toggle(step.id, row)}}},[_vm._v(_vm._s(step.id))])])}))}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerView_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dfc87c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerView_vue__ = __webpack_require__(605);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dfc87c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('styled-title',[_vm._v("Play a song")]),_vm._v(" "),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.play($event)}}},[_vm._v("\n        Play\n    ")]),_vm._v(" "),_c('div',{attrs:{"id":"Notes"}},[(this.showC4)?_c('div',{staticClass:"Note"},[_vm._v("C4")]):_vm._e(),_vm._v(" "),(this.showD4)?_c('div',{staticClass:"Note"},[_vm._v("D4")]):_vm._e(),_vm._v(" "),(this.showE4)?_c('div',{staticClass:"Note"},[_vm._v("E4")]):_vm._e(),_vm._v(" "),(this.showF4)?_c('div',{staticClass:"Note"},[_vm._v("F4")]):_vm._e(),_vm._v(" "),(this.showG4)?_c('div',{staticClass:"Note"},[_vm._v("G4")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotationView_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296df8d5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotationView_vue__ = __webpack_require__(609);
function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-296df8d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotationView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296df8d5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotationView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"div-container"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignSystemView_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c09d630_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignSystemView_vue__ = __webpack_require__(611);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignSystemView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c09d630_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignSystemView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('box',[_c('page-title',[_vm._v("Hello World, this is my first styled component!")]),_vm._v(" "),_c('cta',[_vm._v("CTA")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privateBattles_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2b1dda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privateBattles_vue__ = __webpack_require__(616);
function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a2b1dda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privateBattles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2b1dda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privateBattles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 613:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CenterWrapper',[_c('ContentFrame',[_c('LessonCTA',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoggedIn()),expression:"isLoggedIn()"}],staticClass:"navButton",on:{"click":function($event){_vm.handleLogout()}}},[_vm._v("\n        Log out\n      ")]),_vm._v(" "),_c('LessonCTA',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoggedIn()),expression:"!isLoggedIn()"}],staticClass:"navButton",on:{"click":function($event){_vm.handleLogin()}}},[_vm._v("\n        Log In\n      ")]),_vm._v(" "),_c('PageTitle',[_vm._v("\n      Completed\n    ")]),_vm._v(" "),(_vm.$store.state.completions.length == 0)?_c('div',[_c('LessonCard',[_c('ChoiceBlurb',[_vm._v("Your completed videos will show up here for reference")])],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state.completions),function(completion){return _c('div',[_c('LessonCard',[_c('div',{staticClass:"videoThumbContainer",style:({ backgroundImage: ("url(" + (completion.step.thumbnail) + ")") })}),_vm._v(" "),_c('div',{staticClass:"videoInfo"},[_c('div',{staticClass:"videoTitle"},[_vm._v("\n          "+_vm._s(completion.step.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n          "+_vm._s(completion.step.description)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"videoMeta"})]),_vm._v(" "),_c('div',{staticClass:"ctaStepContainer"},[_c('LessonCTA',{on:{"click":function($event){_vm.openVideo(completion.step)}}},[_c('div',[_vm._v("Re-watch")])]),_vm._v(" "),_c('div',{staticClass:"videoStep"})],1)])],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-nav'),_vm._v(" "),_c('h3',{staticClass:"text-center"},[_vm._v("Secret Startup Battles")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.privateBattles),function(battle){return _c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"panel panel-danger"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v(" "+_vm._s(battle.name)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('p',[_c('span',{staticClass:"badge alert-info"},[_vm._v(" Sponsor: ")]),_vm._v(" "+_vm._s(battle.sponsor)+" ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"badge alert-danger"},[_vm._v(" SeedFund: ")]),_c('strong',[_vm._v(" $"+_vm._s(battle.seedFund)+" ")])])])])])}),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"jumbotron text-center"},[_c('h2',[_vm._v("View Public Startup Battles")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-success",attrs:{"to":"/"}},[_vm._v(" Public Startup Battles ")])],1)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_publicBattles_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2fa054_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_publicBattles_vue__ = __webpack_require__(619);
function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c2fa054"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_publicBattles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2fa054_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_publicBattles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 618:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-nav'),_vm._v(" "),_c('h3',{staticClass:"text-center"},[_vm._v("Daily Startup Battles")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.publicBattles),function(battle){return _c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v(" "+_vm._s(battle.name)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('p',[_c('span',{staticClass:"badge alert-info"},[_vm._v(" Sponsor: ")]),_vm._v(" "+_vm._s(battle.sponsor)+" ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"badge alert-danger"},[_vm._v(" SeedFund: ")]),_c('strong',[_vm._v(" $"+_vm._s(battle.seedFund)+" ")])])])])])}),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.isLoggedIn())?_c('div',{staticClass:"jumbotron text-center"},[_c('h2',[_vm._v("View Private Startup Battles")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-success",attrs:{"to":"/private-battles"}},[_vm._v("Private Startup Battles")])],1):_c('div',{staticClass:"jumbotron text-center"},[_c('h2',[_vm._v("Get Access to Private Startup Battles by Logging In")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192491ad_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(622);
function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-192491ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192491ad_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_callback_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb9085fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_callback_vue__ = __webpack_require__(624);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_callback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb9085fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_callback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UI_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UI_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoView_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3e2cf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoView_vue__ = __webpack_require__(366);
function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b3e2cf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3e2cf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd51b10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Practice_vue__ = __webpack_require__(577);
function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fd51b10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd51b10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Practice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},[339]);


// WEBPACK FOOTER //
// static/js/app.f6f6e9a1276a590a1741.js